import React, { useState, useEffect, useRef } from "react";
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Chart from 'react-apexcharts';
import { Button, Card, Container, Row, Col, Table, Form, Dropdown, Badge } from 'react-bootstrap';
import { faEye, faPencil, faTrashCan, faUser } from "@fortawesome/free-solid-svg-icons";

// import Todolist1 from "../../../assets/images/todolist1.png";

import support_ticket_icon from '../../../assets/images/settings_n.png';
import profile from '../../../assets/images/profile_n.png';

const Overview = () => {
   
  const chartOptions = {
    chart: {
      type: 'donut',
      height: 250
    },
    colors: ['#6C7FF5', '#FF6B7A'],
    labels: ['Active Organization', 'Inactive Organization'],
    dataLabels: {
      enabled: false
    },
    plotOptions: {
      pie: {
        startAngle: -90,
        endAngle: 90,
        offsetY: 10,
        donut: {
          size: '75%',
          labels: {
            show: true,
            total: {
              show: true,
              label: 'Total Organization',
              fontSize: '14px',
              fontWeight: 400,
              color: '#9CA3AF',
              formatter: function () {
                return '100';
              }
            },
            value: {
              show: true,
              fontSize: '32px',
              fontWeight: 600,
              color: '#1F2937',
              offsetY: -10,
              formatter: function (val) {
                return val;
              }
            },
            name: {
              offsetY: 20
            }
          }
        }
      }
    },
    legend: {
      show: false
    },
    grid: {
      padding: {
        bottom: -80
      }
    },
    tooltip: {
      enabled: true,
      y: {
        formatter: function (val) {
          return val + ' User';
        }
      }
    }
  };

  const series = [60, 40];



  const SegmentBarseries = [
    {
      name: "#6C7FF5",
      data: [50]
    },
    {
      name: "#FF6B7A",
      data: [20]
    },
    {
      name: "grey",
      data: [30]
    }
  ];

  const segmentBarOptions = {
    chart: {
      type: "bar",
      stacked: true,
      toolbar: { show: false },
    },
    plotOptions: {
      bar: {
        horizontal: true,
        barHeight: "80%",
        dataLabels: {
          position: "center"
        },
        borderRadius: 4
      }
    },
    xaxis: {
      max: 100,
      labels: { show: false },
      axisTicks: { show: false },
      axisBorder: { show: false }
    },
    yaxis: {
      labels: { show: false }
    },
    dataLabels: {
      enabled: true,
      formatter: (val) => `${val}%`,
      style: {
        colors: ["#fff"],
        fontSize: "14px",
        fontWeight: 600
      }
    },
    colors: ["#6C7FF5", "#FF6B7A", "grey"],
    grid: { show: false },
    legend: { show: false }
  };




  return (
    <div>
      <div className='row'>
        <div className='col-md-8'>
          <Card>
            <Card.Body>
              <div className='d-flex justify-content-between'>
                <div className='d-flex gap-2'>
                  <div>
                    <img src='' />
                  </div>
                  <div>
                    Organization Overview
                  </div>

                </div>
                <div className=''>
                  <Dropdown>
                    <Dropdown.Toggle variant="light" id="dropdown-basic" className='adduld'>
                      Weekly hh<FontAwesomeIcon icon={faChevronDown} />
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      <Dropdown.Item >New Stock</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
              <div>
                <Chart
                  options={chartOptions}
                  series={series}
                  type="donut"
                  height={350}
                />
              </div>
            </Card.Body>
          </Card>

          <div className='mt-2'>
            <Card>
              <Card.Body>
                <div className='d-flex justify-content-between'>
                  <div className='d-flex gap-2'>
                    <div>
                      <img src='' />
                    </div>
                    <div>
                      Request List Overview
                    </div>

                  </div>
                  <div className=''>
                    <Dropdown>
                      <Dropdown.Toggle variant="light" id="dropdown-basic" className='adduld'>
                        Weekly <FontAwesomeIcon icon={faChevronDown} />
                      </Dropdown.Toggle>

                      <Dropdown.Menu>
                        <Dropdown.Item >New Stock</Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </div>
                <Chart
                  options={segmentBarOptions}
                  series={SegmentBarseries}
                  type="bar"
                  height={100}
                />
              </Card.Body>
            </Card>
          </div>
        </div>
        <div className='col-md-4'>
          <div className="admin_dashboard_dv">
            <div className="opnpln-box">
              <h4><span className="me-3"><img src={support_ticket_icon} alt="" /></span>Support Ticket</h4>
              <div className="selct_drpdwn">
                <Form.Select aria-label="Default select example">
                  <option>Weekly</option>
                  <option value="weekly">Weekly</option>
                  <option value="monthly">Monthly</option>
                  <option value="yearly">Yearly</option>
                </Form.Select>
              </div>
              <div className='support_ticket_main'>
                <div className="support_ticket_list_wrap">
                  <Row>
                    <Col md={6}>
                      <div className="title">
                        <h6>Support Ticket 1</h6>
                        <p>#123456</p>
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="title text-end tidate">
                        <h6><FontAwesomeIcon icon={faEye} className="view" /></h6>
                        <p>Apr 09,2025</p>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={8}>
                      <div className="user_dv d-flex align-items-center">
                        <img src={profile} alt="" className="me-2" /><span>Carol C. Flemming</span>
                      </div>
                    </Col>
                    <Col md={4}>
                      <div className="text-end tidate">
                        <Button variant="warning" size="sm" className="new_btn">
                          New
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                <div className="support_ticket_list_wrap">
                  <Row>
                    <Col md={6}>
                      <div className="title">
                        <h6>Support Ticket 1</h6>
                        <p>#123456</p>
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="title text-end tidate">
                        <h6><FontAwesomeIcon icon={faEye} className="view" /></h6>
                        <p>Apr 09,2025</p>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={8}>
                      <div className="user_dv d-flex align-items-center">
                        <img src={profile} alt="" className="me-2" /><span>Carol C. Flemming</span>
                      </div>
                    </Col>
                    <Col md={4}>
                      <div className="text-end tidate">
                        <Button variant="warning" size="sm" className="new_btn">
                          New
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                <div className="support_ticket_list_wrap">
                  <Row>
                    <Col md={6}>
                      <div className="title">
                        <h6>Support Ticket 1</h6>
                        <p>#123456</p>
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="title text-end tidate">
                        <h6><FontAwesomeIcon icon={faEye} className="view" /></h6>
                        <p>Apr 09,2025</p>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={8}>
                      <div className="user_dv d-flex align-items-center">
                        <img src={profile} alt="" className="me-2" /><span>Carol C. Flemming</span>
                      </div>
                    </Col>
                    <Col md={4}>
                      <div className="text-end tidate">
                        <Button variant="warning" size="sm" className="new_btn">
                          New
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                <div className="support_ticket_list_wrap">
                  <Row>
                    <Col md={6}>
                      <div className="title">
                        <h6>Support Ticket 1</h6>
                        <p>#123456</p>
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="title text-end tidate">
                        <h6><FontAwesomeIcon icon={faEye} className="view" /></h6>
                        <p>Apr 09,2025</p>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={8}>
                      <div className="user_dv d-flex align-items-center">
                        <img src={profile} alt="" className="me-2" /><span>Carol C. Flemming</span>
                      </div>
                    </Col>
                    <Col md={4}>
                      <div className="text-end tidate">
                        <Button variant="warning" size="sm" className="new_btn">
                          New
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                <div className="support_ticket_list_wrap">
                  <Row>
                    <Col md={6}>
                      <div className="title">
                        <h6>Support Ticket 1</h6>
                        <p>#123456</p>
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="title text-end tidate">
                        <h6><FontAwesomeIcon icon={faEye} className="view" /></h6>
                        <p>Apr 09,2025</p>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={8}>
                      <div className="user_dv d-flex align-items-center">
                        <img src={profile} alt="" className="me-2" /><span>Carol C. Flemming</span>
                      </div>
                    </Col>
                    <Col md={4}>
                      <div className="text-end tidate">
                        <Button variant="warning" size="sm" className="new_btn">
                          New
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                <div className="support_ticket_list_wrap">
                  <Row>
                    <Col md={6}>
                      <div className="title">
                        <h6>Support Ticket 1</h6>
                        <p>#123456</p>
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="title text-end tidate">
                        <h6><FontAwesomeIcon icon={faEye} className="view" /></h6>
                        <p>Apr 09,2025</p>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={8}>
                      <div className="user_dv d-flex align-items-center">
                        <img src={profile} alt="" className="me-2" /><span>Carol C. Flemming</span>
                      </div>
                    </Col>
                    <Col md={4}>
                      <div className="text-end tidate">
                        <Button variant="warning" size="sm" className="new_btn">
                          New
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                <div className="support_ticket_list_wrap">
                  <Row>
                    <Col md={6}>
                      <div className="title">
                        <h6>Support Ticket 1</h6>
                        <p>#123456</p>
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="title text-end tidate">
                        <h6><FontAwesomeIcon icon={faEye} className="view" /></h6>
                        <p>Apr 09,2025</p>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={8}>
                      <div className="user_dv d-flex align-items-center">
                        <img src={profile} alt="" className="me-2" /><span>Carol C. Flemming</span>
                      </div>
                    </Col>
                    <Col md={4}>
                      <div className="text-end tidate">
                        <Button variant="warning" size="sm" className="new_btn">
                          New
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                <div className="support_ticket_list_wrap">
                  <Row>
                    <Col md={6}>
                      <div className="title">
                        <h6>Support Ticket 1</h6>
                        <p>#123456</p>
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="title text-end tidate">
                        <h6><FontAwesomeIcon icon={faEye} className="view" /></h6>
                        <p>Apr 09,2025</p>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={8}>
                      <div className="user_dv d-flex align-items-center">
                        <img src={profile} alt="" className="me-2" /><span>Carol C. Flemming</span>
                      </div>
                    </Col>
                    <Col md={4}>
                      <div className="text-end tidate">
                        <Button variant="warning" size="sm" className="new_btn">
                          New
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Overview